import type { ComponentType } from "react";

import type { HomepageVariant } from "../variantResolver";

import FigmaLandingPageA from "./figmaA/FigmaLandingPageA";
import FigmaLandingPageB from "./figmaB/FigmaLandingPageB";

/** The contract every homepage arm implements. */
export interface HomepageVariantProps {
  isAuthenticated: boolean;
  onCTAClick: (ctaVariant: string) => void;
  /**
   * Whether the hero says Log in rather than registering first: a device
   * somebody has signed in on, with nobody signed in now (#1066,
   * `offersLogIn`).
   */
  offersLogIn: boolean;
}

/**
 * Every homepage arm this app can render, keyed by its experiment label.
 *
 * `Record<HomepageVariant, …>` keeps this honest: widening
 * `RENDERABLE_VARIANTS` without adding the component here is a type error, so
 * the experiment can never be told about an arm that would render nothing.
 *
 * It lives apart from `LegacyHomepage` so the per-arm render test can mount
 * every registered arm without pulling in tRPC, analytics and auth.
 */
export const VARIANT_PAGES: Record<HomepageVariant, ComponentType<HomepageVariantProps>> = {
  A: FigmaLandingPageA,
  B: FigmaLandingPageB,
};
